import { withStyles } from '@material-ui/core/styles';
import appConstants from '../../../appConstants';
const styles = (theme) => ({
  container: {
    backgroundColor: theme.gridOverlayBGColor,
    color: theme.gridOverlayFontColor,
    padding: 10,
    border: `1px solid ${theme.gridOverlayFontColor}`
  },
  error: {
    color: theme.KPI.KPINegative,
    border: `1px solid ${theme.KPI.KPINegative}`
  }
});
const CustomNoRowsOverlay = ({ message, classes, error }) => {
  let errorClass = "";
  if(error === appConstants.GRID_STATUS.ERROR){
    errorClass = classes.error;
  }
  return (
    <span key="non-loading" className={`${classes.container} ${errorClass}`}>
      {message}
    </span>
  );
};

export default withStyles(styles)(CustomNoRowsOverlay);
